import React from 'react';
import Sidebar from './Sidebar';
import DashboardTopbar from './DashboardTopbar';

interface AppLayoutProps {
  children: React.ReactNode;
  activeRoute?: string;
  onRefresh?: () => void;
  lastRefreshed?: Date | null;
}

export default function AppLayout({ children, activeRoute, onRefresh, lastRefreshed }: AppLayoutProps) {
  return (
    <div className="flex h-screen bg-background overflow-hidden">
      <Sidebar activeRoute={activeRoute} />
      <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
        <DashboardTopbar onRefresh={onRefresh} lastRefreshed={lastRefreshed} />
        <main className="flex-1 overflow-y-auto overflow-x-hidden">
          <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 py-6">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}